import { definePageInfoService, GetNavigationState } from '@volkswagen-onehub/page-info-service';

export const createPageInfoService = (getNavigationState: GetNavigationState) =>
  definePageInfoService(getNavigationState, {
    seo: { pageTitle: 'Digital Giveaway' },
    logoCategory: 'private', // default
  }) as unknown;
